module.exports = __webpack_public_path__ + "static/media/perks.f399d974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/perks.jpg
// module id = 181
// module chunks = 0